import { getStorageItem, setStorageItem } from 'CorePackage/MainModule/common/localStore';
import { StorageNamesEnum } from 'CorePackage/MainModule/enums/StorageNamesEnum';

import { initialErknmAnalyticsTableColumns } from '../contstants/initialErknmAnalyticsTableColumns';
import { ErknmAnalyticsActionsEnum } from '../enums/ErknmAnalyticsActionsEnum';
import { IErknmAnalyticsState } from '../interfaces/IErknmAnalyticsState';
import { IErknmAnalyticsTableColumn } from '../interfaces/IErknmAnalyticsTableColumn';
import { ErknmAnalyticsAction } from '../types/ErknmAnalyticsAction';

const columnsRaw = getStorageItem<IErknmAnalyticsTableColumn[]>(StorageNamesEnum.ERKNM_ANALYTICS_COLUMNS);
const initialColumns: IErknmAnalyticsTableColumn[] = columnsRaw || initialErknmAnalyticsTableColumns;

const initialState: IErknmAnalyticsState = {
  data: [],
  page: 0,
  hasMoreData: true,
  localDateTime: null,
  tableColumns: initialColumns,
  knmList: [],
  knmPage: 0,
  knmPageCount: 0,
  knmTotalCount: 0,
  knmOrder: null,
};

export function erknmAnalyticsReducer(state: IErknmAnalyticsState = initialState, action: ErknmAnalyticsAction) {
  switch (action.type) {
    case ErknmAnalyticsActionsEnum.ERKNM_ANALYTICS_SET_DATA: {
      const newState: IErknmAnalyticsState = {
        ...state,
        data: action.payload.data,
        page: action.payload.page,
        hasMoreData: action.payload.hasMoreData,
        localDateTime: action.payload.localDateTime,
      };

      return newState;
    }
    case ErknmAnalyticsActionsEnum.ERKNM_ANALYTICS_SET_FILTER: {
      const newState: IErknmAnalyticsState = {
        ...state,
        filter: action.payload.filter,
      };

      return newState;
    }
    case ErknmAnalyticsActionsEnum.ERKNM_ANALYTICS_SET_TABLE_COLUMNS: {
      const newState: IErknmAnalyticsState = {
        ...state,
        tableColumns: [...initialErknmAnalyticsTableColumns, ...action.payload.columns],
      };

      setStorageItem(StorageNamesEnum.ERKNM_ANALYTICS_COLUMNS, newState.tableColumns);

      return newState;
    }
    case ErknmAnalyticsActionsEnum.ERKNM_ANALYTICS_SET_KNM_LIST: {
      const { data: knmList, page: knmPage, totalCount: knmTotalCount, pageCount: knmPageCount } = action.payload;
      const newState: IErknmAnalyticsState = {
        ...state,
        knmList,
        knmPage,
        knmTotalCount,
        knmPageCount,
      };

      return newState;
    }
    case ErknmAnalyticsActionsEnum.ERKNM_ANALYTICS_SET_ORDER: {
      const newState: IErknmAnalyticsState = {
        ...state,
        knmOrder: action.payload.order,
      };

      return newState;
    }
    default:
      return state;
  }
}
